<script lang="ts">import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { formatNumber, formatRankDisplayWithOptionalRankPrefix, getPercentage, hardRefreshSelfInfoInternal, isMobile, loggedIn, refreshVipState, statePointsToNextLevel, stateSelfInfo, stateUserLevel, stateUsername, stateUserRank, stateVipProgress } from "@infinitro/global";
import { Icon } from "@infinitro/rank-badges";
import { Text } from "@infinitro/text";
import { onDestroy, onMount } from "svelte";
import ProgressBar from "./progress-bar.svelte";
import TopCard from "./top-card.svelte";
let screenWidth = window.innerWidth;
let username;
let iconSizeMain;
let nextLevelPoints = 0;
let currentLevelPoints = 0;
let missingPointsForNextLevel = 0;
let currentLevelPointsPercentage = 0;
stateUsername.subscribe((value) => {
	username = value;
});
const checkViewport = () => {
	screenWidth = window.innerWidth;
};
onMount(async () => {
	window.addEventListener("resize", checkViewport);
	try {
		await refreshVipState();
	} catch (error) {
		console.error("Error fetching user info", error);
	}
});
onDestroy(() => {
	window.removeEventListener("resize", checkViewport);
});
$: {
	if (screenWidth >= 1440) {
		// For screens larger than or equal to 1440px
		iconSizeMain = 110;
	} else if (screenWidth >= 1280) {
		// For screens between 1280px and 1439px
		iconSizeMain = 105;
	} else if (screenWidth >= 768) {
		// For screens between 768px and 1279px
		iconSizeMain = 105;
	} else {
		// For screens smaller than 768px
		iconSizeMain = 70;
	}
}
$: if ($stateSelfInfo) {
	nextLevelPoints = $stateSelfInfo.vipPointsNext ?? 0;
	currentLevelPoints = $stateSelfInfo.vipPoints ?? 0;
	missingPointsForNextLevel = nextLevelPoints - currentLevelPoints;
	currentLevelPointsPercentage = getPercentage(currentLevelPoints, nextLevelPoints);
}
$: backgroundImage = $loggedIn === true && $stateSelfInfo ? cfgToThemeCdnPath("/top-section/big-left-player.png") : cfgToThemeCdnPath("/top-section/main-default.png");
let triedRefresh = false;
$: if ($loggedIn && $stateSelfInfo && !$stateSelfInfo?.vipRank && !triedRefresh) {
	triedRefresh = true;
	hardRefreshSelfInfoInternal();
}
$: rankBadgeLabel = formatRankDisplayWithOptionalRankPrefix($stateSelfInfo?.vipRank, $t(Verbiage.rank), $stateUi.vip?.showRankPrefixBeforeDisplayName);
</script>

<div class="top-card-container">
	<TopCard alternative {backgroundImage} height="100%" width="100%" />
	{#if $stateSelfInfo}
		<div class="content-top-card">
			<div class="content-top-card-container">
				<div class="rank-badges">
					<div class="rank-badge">
						<Icon level={$stateUserLevel} rank={$stateUserRank} size={iconSizeMain} />
					</div>
				</div>
				<div class="user-info">
					<div class="badge">
						<span>
							{rankBadgeLabel}
						</span>
					</div>
					<div class="username-container">
						<h2 class="card-section-title">
							{username.toUpperCase() || 'USERNAME'}
						</h2>
						<div class="description-container">
							<Text
								textColor="gray"
								bodySize="small"
								type="body"
								customStyle={$isMobile
									? 'font-weight: 100; font-size: 0.7rem;'
									: 'font-size: 14px;'}
							>
								{$t(Verbiage.welcome_back)}
							</Text>
						</div>
					</div>
				</div>
				<div class="user-info-container">
					<div class="progress-container">
						<ProgressBar progress={$stateVipProgress} />
					</div>
					<div class="experience">
						<span class="d-flex">
							<p class="bold-font">
								{formatNumber($statePointsToNextLevel ?? 0, true, false)}
							</p>
							<p>{$t(Verbiage.to_next_lvl)}</p>
						</span>
					</div>
					<!--<p class="upcoming-rewards">
          {$t(Verbiage.upcoming_reward)}
          <img
            src={cfgToThemeCdnPath('/top-section/reward.png')}
            alt="Reward Icon"
            class="money-img"
          />
        </p>-->
				</div>
			</div>
		</div>
	{/if}
</div>

<style>
	.content-top-card {
		position: absolute;
		z-index: 40;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		overflow: hidden;
		border-radius: 16px;
		padding-left: 1rem;
		padding-right: 1rem
}

	@media (min-width: 640px) {
		.content-top-card {
				padding-left: 3rem;
				padding-right: 3rem
		}
	}

	@media (min-width: 1280px) {
		.content-top-card {
				padding: 1rem
		}
	}

	.content-top-card-container {
		position: relative;
		z-index: 40;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: space-around
}

	.top-card-container {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: space-between
}

	.description-container {
		margin-bottom: 0px
}

	.user-info-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.25rem;
		padding-bottom: 0.75rem
}

	.experience {
		width: 100%;
		align-items: center;
		justify-content: center;
		font-size: 0.65rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main)
}

	@media (min-width: 640px) {
		.next-level-info,
		.experience {
				font-size: 14px
		}
	}

	@media (min-width: 1280px) {
		.next-level-info,
		.experience {
				font-size: 14px
		}
	}

	.d-flex {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		gap: 0.5rem
}

	.progress-container {
		width: 100%
}

	@media (min-width: 1024px) {
		.progress-container {
				margin-top: 0.25rem
		}

		.next-level-info {
				display: flex
		}
	}

	.money-img {
		position: static;
		width: 14px
}

	@media (min-width: 640px) {
		.money-img {
				width: 14px
		}
	}

	.badge {
		z-index: 40;
		border-radius: 0.5rem;
		background-color: var(--color-primary-500);
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		font-size: 0.6rem;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1))
}

	@media (min-width: 1280px) {
		.badge {
				font-size: 0.8rem
		}
	}

	.rank-badges {
		z-index: 40;
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center
}

	.rank-badge {
		position: relative;
		z-index: 40
}

	.bold-font {
		font-weight: 700
}

	.user-info {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		padding-top: 0.375rem
}

	.username-container {
		display: flex;
		width: 100%;
		max-width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center
}

	.card-section-title {
		max-width: 100%;
		overflow: hidden;
		text-overflow: clip;
		text-align: center;
		font-size: 12px;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2)
}

	@media (min-width: 640px) {
		.card-section-title {
				font-size: 24px
		}
	}

	@media (min-width: 1280px) {
		.card-section-title {
				font-size: 18px;
			font-size: clamp(8px, 1.1cqi, 18px) !important
		}
	}

	@media (min-width: 1280px) and (max-width: 1343px) {
		.experience > span > p {
				font-size: 12px;
				font-weight: 700
		}
	}

	@media (min-width: 1343px) {
		.experience > span > p {
				font-size: 14px
		}
	}

	.upcoming-rewards {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		font-size: 10px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
</style>
